import classNames from 'classnames'
import Typography, {
  TypographyTag,
  TypographyVariant,
} from '~/components/Typography'
import styles from './CartPromoBanner.module.css'
import { CartPromoBannerProps } from './CartPromoBanner.types'

export const CartPromoBanner = ({ children }: CartPromoBannerProps) => {
  return (
    <div className='w-full text-center bg-background-cart-banner px-2 py-2.5 rounded-md'>
      <Typography
        tag={TypographyTag.p}
        variant={TypographyVariant.BodyRegularExtraLineHeight}
        className={classNames('text-secondary-muted', styles.promoText)}>
        {children}
      </Typography>
    </div>
  )
}
